<template>
  <v-dialog v-model="settingsDialog" max-width="600px">
    <template v-slot:activator="{ on }">
     <v-btn text v-on="on" class="primary">Settings</v-btn>
   </template>
   <v-card>


    <v-toolbar dense dark color="primary" style="">
      <v-btn icon dark @click="settingsDialog = false">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title class="subheading">Settings</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="saveAll" class=""><v-icon class="mr-2">save</v-icon>Save</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <!-- <v-card-text> -->

      <template>
        <div>
          <v-tabs
          background-color="black accent-4"
          class="elevation-2"
          dark
          centered
          grow
          >
          <v-tab>
            User Settings
          </v-tab>
          <v-tab v-if="$store.state.user.admin">
            Company Settings
          </v-tab>

          <v-tab-item>
            <UserSettings />
          </v-tab-item>

          <v-tab-item>
            <template>
              <div>
                <v-tabs
                background-color=" accent-4"
                class="elevation-2"
                outline
                centered
                grow
                >
                <v-tab>
                  Page Layout
                </v-tab>
                <v-tab>
                  Discounts
                </v-tab>
                <v-tab>
                  Financing
                </v-tab>
                <v-tab>
                  Email
                </v-tab>
               <!--  <v-tab>
                  Subscription
                </v-tab> -->

                <v-tab-item>
                  <CompanySettings />
                </v-tab-item>

                <v-tab-item>
                  <Discounts />
                </v-tab-item>

                <v-tab-item>
                  <Financing />
                </v-tab-item>

                <v-tab-item>
                  <EmailLayout />
                </v-tab-item>

              </v-tabs>
            </div>
          </template>
          <!-- <v-col>
            <AppSettings />
          </v-col> -->
        </v-tab-item>
      </v-tabs>
    </div>
  </template>
  <!-- </v-card-text> -->

</v-card>
</v-dialog>

</template>

<script>
import format from 'date-fns/format'
import UserSettings from './UserSettings'
import CompanySettings from './CompanySettings'
import AppSettings from './AppSettings'
import EmailLayout from './EmailLayout'
import Discounts from './Discounts'
import Financing from './Financing'

// import db from '@/fb'

export default {
  components: { UserSettings, CompanySettings, AppSettings, EmailLayout, Discounts, Financing},
  data() {
    return {
      inputRules: [
      v => !!v || 'This field is required',
      v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      loading: false,
    }
  },
  methods: {
    saveAll () {
      let companyInfo = {
        image: this.$store.state.company.image,
        companyName: this.$store.state.company.companyName,
        companyPhone: this.$store.state.company.companyPhone,
        companyWebsite: this.$store.state.company.companyWebsite,
        footer: this.$store.state.company.footer,
        priceDisclosure: this.$store.state.company.priceDisclosure,
        emailMessage: this.$store.state.company.emailMessage
      }
      if(this.$store.state.user.admin == true){
        this.$store.dispatch('updateCompanyInfo', companyInfo)
      }
      this.$store.dispatch('validateKey', {cId: this.$store.state.user.cId, callBack: 'updateUser'})
      // this.$store.commit('drawerMenu', false)
      this.$store.commit('setSnack', 'Settings Saved!') 
      this.settingsDialog = false
    },
  },
  computed: {
    settingsDialog: {
      set(settingsDialog) {
        this.$store.state.user == null 
        ? this.$store.commit('setSnack', 'please sign in') 
        : this.$store.commit('settingsDialog', settingsDialog)
      },
      get() {
        return this.$store.state.settingsDialog
      }
    }
  },
  created() {

  }
}
</script>
